/* eslint-disable no-nested-ternary */
import React from 'react';
// Material UI core
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { withTranslation } from 'config/i18n';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
  root: {},
  tableContainer: {
    marginTop: theme.spacing(2),
  },
}));
const ERTable = ({
  columns, rows, total, totalIndex,
}) => {
  const classes = useStyles();
  const tableContainerRef = React.useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div className={classes.root}>
      {!isMobile ? (
        columns ? (
          <TableContainer
            ref={tableContainerRef}
            className={classes.tableContainer}
          >
            <Table>
              <TableHead>
                <TableRow>
                  {Array.isArray(columns)
                    && columns.map((column, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <TableCell key={`column-${index}`}>{column}</TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map((row, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <TableRow key={`row-${index}`}>
                      {row?.map((cell, cellIndex) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <React.Fragment key={`cel-${cellIndex}`}>
                            {cellIndex == 0 ? (
                              <TableCell component="th" scope="row">
                                {cell}
                              </TableCell>
                            ) : (
                              <TableCell>{cell}</TableCell>
                            )}
                          </React.Fragment>
                        ))}
                    </TableRow>
                  ))}
                {total && (
                  <TableRow className="tfoot">
                    {[...Array(totalIndex)].map((i, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <TableCell key={index} />
                    ))}
                    <TableCell>{total}</TableCell>
                    <TableCell colSpan={columns ? columns.length - 2 : 3} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <>
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
          </>
        )
      ) : (
        <div ref={tableContainerRef} className={classes.tableContainer}>
          {rows?.map((row, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Paper className="tableRowCard" elevation={1} key={index}>
                {row?.map((cell, cellIndex) => (
                    <div key={cell} className="tableRowCard__column">
                      <label className="tableRowCard__column-name">
                        {columns
                          && Array.isArray(columns)
                          && columns[cellIndex]}
                      </label>
                      <span>{cell}</span>
                    </div>
                  ))}
              </Paper>
            ))}
          {total && (
            <Paper className="tableRowCard" elevation={1}>
              <div className="tableRowCard__column total">
                <span>{total}</span>
              </div>
            </Paper>
          )}
        </div>
      )}
    </div>
  );
};

export default withTranslation(['fe_bookings'])(ERTable);
